export const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  let result = '';
  if (match) {
    if (match[2] == 'null') {
      return result;
    }
    result = match[2].replace(/%22/gi, '');
  }
  return result;
};
